import { useState, useEffect, useCallback, useRef,useMemo } from 'react';
import { message } from 'antd';
import { ResDataType } from '@/services/ajax';
import { debounce } from 'lodash';

const useUniversalTable = <T extends unknown>(

  requestMethod: (body: Record<string, any>) => Promise<any>,
  // 初始参数配置
  initialParams: Record<string, any> = {},
) => {
  const [searchParams, setSearchParams] = useState({
    PageIndex: 1,
    PageSize: 15,
    ...initialParams
  });
  
  const [data, setData] = useState<T[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const abortControllerRef = useRef<AbortController>();

  // 核心请求方法
  const fetchData = useCallback(async () => {
    try {

      setLoading(true);
      // 调用传入的请求方法
      const res = await requestMethod({
        ...searchParams,
      });

      if (res.code == 0) {
        const data = res.data as ResDataType
        setData(data && data?.list || []);
        setTotal(data?.total || 0);
      } else {
        message.error(res.message || '请求失败');
      }
    } catch (error) {
      if ((error as Error).name !== 'AbortError') {
        message.error((error as Error).message || '请求异常');
      }
    } finally {
      setLoading(false);
    }
  }, [requestMethod, searchParams]);

  // 自动发起请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // 处理分页变化
  const handlePageChange = (page: number) => {
    setSearchParams(prev => ({ ...prev, PageIndex: page }));
  };

  

  // 处理搜索条件变化
  const handleSearchChange = (newParams: Record<string, any>) => {
    setSearchParams(prev => ({
      ...prev,
      ...newParams,
      PageIndex: 1  // 搜索条件变化重置页码
    }));
  };

  const handleSearch = useMemo(
    () => debounce((values: Record<string, any> = {}) => {
      handleSearchChange(values);
    }, 300),
    [handleSearchChange]
  );

  return {
    data,
    total,
    loading,
    fetchData,
    searchParams,
    handleSearch,
    handlePageChange,
    handleSearchChange,
    setSearchParams // 暴露完整参数设置方法
  };
};

// 导出Hook
export default useUniversalTable;